

import axios from 'axios';

const prefix = a => 'Panel/CarClaimStatusRow' + (a ? `/${a}` : '');

export default {
  index(params, config = {}) {
    const url = prefix();
    return params === true ? url : axios.get(url, {...config, params});
  },
  fields(params, config = {}) {
    const url = 'Panel/CarClaimStatusfields';
    return params === true ? url : axios.get(url, {...config, params});
  },
  store(data = {}, config = {}) {
    const url = prefix();
    return data === true ? url : axios.post(url, data, config);
  },
  update(id, data = {}, config = {}) {
    const url = prefix(id);
    return id === true ? url : axios.put(url, data, config);
  },
  show(id, config = {}) {
    const url = prefix(id);
    return id === true ? url : axios.get(url, config);
  },
  destroy(id, config = {}) {
    const url = prefix(id);
    return id === true ? url : axios.delete(url, config);
  },
  // The "تعميد الشركة" table for one approval-request row. Read-only, admin
  // only: it computes the figures from the claim and stores nothing.
  companyApproval(id, config = {}) {
    return axios.get(prefix(`${id}/companyApproval`), config);
  },
  // The same table resolved from the claim: the actions dialog lists only the
  // latest status row, which is almost never the approval request, so the
  // button there cannot depend on the row being on screen.
  companyApprovalForClaim(claimId, config = {}) {
    return axios.get(`Panel/CarClaim/${claimId}/companyApproval`, config);
  },
  // What the "مراسلة الشركة" screen opens with: the client's employee
  // addresses, the policy number as subject, and a body around the table.
  companyMailDraft(claimId, config = {}) {
    return axios.get(`Panel/CarClaim/${claimId}/companyMailDraft`, config);
  },
  // Sends it. This one actually leaves the building.
  // Multipart whenever files ride along - a JSON body cannot carry them.
  companyMail(claimId, data, config = {}) {
    const url = `Panel/CarClaim/${claimId}/companyMail`;
    const files = data.attachments || [];
    if (!files.length) {
      return axios.post(url, {to: data.to, subject: data.subject, html: data.html}, config);
    }

    const form = new FormData();
    (data.to || []).forEach(a => form.append('to[]', a));
    form.append('subject', data.subject);
    form.append('html', data.html);
    files.forEach(f => form.append('attachments[]', f, f.name));

    return axios.post(url, form, {
      ...config,
      headers: {...(config.headers || {}), 'Content-Type': 'multipart/form-data'}
    });
  },
  // The claim's money for the actions dialog: amount, discount, amount after
  // the discount, collected so far and still owed.
  financials(claimId, config = {}) {
    return axios.get(`Panel/CarClaim/${claimId}/financials`, config);
  },
  // Records the claim's own discount percentage; returns the recomputed figures.
  saveDiscount(claimId, discountPercent, config = {}) {
    return axios.post(`Panel/CarClaim/${claimId}/discount`, {discount_percent: discountPercent}, config);
  },
  // Remember how this admin left the screen, so it opens the same next time.
  saveLayout(claimId, kind, payload, shared = false, config = {}) {
    return axios.post(`Panel/CarClaim/${claimId}/saveLayout`, {kind, payload, shared}, config);
  }
};
